import Vue from 'vue'
import VueRouter from 'vue-router';

import 'element-ui/lib/theme-chalk/index.css';

// import './theme/element1/index.css'
import $ from 'jquery'
import axios from 'axios';
import VueJsonp from 'vue-jsonp'
import Breadcrumb from './assets/js/components/ExampleComponent.vue';
import NbTags from './assets/js/pages/common/NbTags.vue';
import Help from './assets/js/pages/common/Help.vue';
import ElementUI from "element-ui";
import VCharts from "v-charts";
import region from './assets/js/pages/common/region';
import { applyPolyfills, defineCustomElements } from '@nobook/video-component/loader';
// import Purchasing from './assets/js/pages/common/Purchasing';
import './assets/sass/exam.scss';

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/test-\w*/];

applyPolyfills().then(() => {
  defineCustomElements();
});

Vue.use(VueRouter);
Vue.use(VueJsonp);
Vue.use(ElementUI);
Vue.use(VCharts);
Vue.prototype.$ajax = axios;

axios.interceptors.response.use(
  response => {
      return response;
  },
  error => {
      if (error.response.headers.nbcode == '302') {
          _url = error.response.headers.nbcallback
          window.location.href = _url

      }
      if (error.response.status == 401) {
          const redirect = window.location.href;
          window.location.href = `${window.__nb_passport_api}?return_url=${redirect}`;
      }
      return;
  }
);

Vue.config.ignoredElements = ['additi-exam', 'additi-prepare']

// register dashboard components

Vue.component('db-breadcrumb', Breadcrumb);
Vue.component('nb-help', Help);
Vue.component('nb-tags', NbTags);
Vue.component('nb-region', region);
// Vue.component('nb-pay', Purchasing);

//根据登录为教师学生更换
import TApp from './assets/js/Exam.vue'
import Troutes from "./assets/js/routes_exam";
import SApp from './assets/js/Student.vue'
import Sroutes from "./assets/js/routes_student";

import Global from './global'
Vue.prototype.GLOBAL = Global;
import { getuserinfo } from './assets/js/api/exam_api'

let router;

//axios加入user token;
$.ajax({
  // url:'http://passport.nobook.cc/login/getexamtoken',
  url:Vue.prototype.GLOBAL.url.pact + '://passport.' + Vue.prototype.GLOBAL.url.path + '/login/getexamtoken',
  type: 'GET',
  dataType:'jsonp',
  jsonp: 'jsoncallback',
  success:function (res){
    if(res.code == 200){
      axios.defaults.headers.common['token'] = res.data.token;
      Vue.prototype.GLOBAL.userLoginInfo = res.data;
      Vue.prototype.GLOBAL.request.getVip();
      getuserinfo({pid:Vue.prototype.GLOBAL.pid}).then((res)=>{
        if(res.code == 0){
          Vue.prototype.GLOBAL.userInfo = res.data;
          let _userType = '';
          if(res.data.userInfo){
            _userType = res.data.userInfo.userType;

          }else{
            let _url = window.location.href;
            window.location = Vue.prototype.GLOBAL.url.pact + '://passport.' + Vue.prototype.GLOBAL.url.path + '?return_url=' + _url;
          }
          let routes = _userType==1?Sroutes:Troutes;
          let App = _userType == 1?SApp:TApp;
          router = new VueRouter({
            routes,
            mode: 'hash',
            linkActiveClass: 'active'
          });

          new Vue({
            render: h => h(App),
            router
          }).$mount('#examApp');
        }
      });
    }else{
      let _url = window.location.href;
      window.location = Vue.prototype.GLOBAL.url.pact + '://passport.' + Vue.prototype.GLOBAL.url.path + '?return_url=' + _url;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js